import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';

const Publish = ({ formData, handleFinishWithPublish, handleFinishWithoutPublish }) => {

  return (
    <Box>
      <Typography variant="body1" style={{ marginBottom: '24px' }}>
        Ready to take the next big step and publish your Partial Sale to the marketplace?
      </Typography>
      
      <Box display="flex" gap={2} justifyContent="center" flexDirection={{ xs: 'column', sm: 'row' }}>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          onClick={handleFinishWithoutPublish}
          style={{ 
            minWidth: '200px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          No, Save for Later
        </Button>
        
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleFinishWithPublish}
          style={{ 
            minWidth: '200px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          Yes, Publish
        </Button>
      </Box>
      
      <Box mt={3}>
        <Typography variant="body2" color="textSecondary" align="center">
          You can always change your mind and publish later from your dashboard.
        </Typography>
      </Box>
    </Box>
  );
}

export default Publish;

